export default "__VITE_ASSET__51f66f3f__"